import React from "react";
import * as PropTypes from "prop-types";
import { Link } from "react-scroll";
import { makeStyles } from "@material-ui/styles";
import classNames from "classnames";
import IconButton from "@material-ui/core/IconButton";
import MuiAppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuIcon from "@material-ui/icons/Menu";
import rhscLogo from "../../images/rhsc_logo_actual_size.svg";
import cgaLogo from "../../images/cga_logo_actual_size.svg";
import styleConstants, { toolbarHeight } from "../../styleConstants";
import HyperLink from "./HyperLink";

const useStyles = makeStyles(theme => ({
  cgaLogo: {
    marginLeft: "2rem",
    width: 96,
    height: 29,
    cursor: "pointer"
  },
  container: {
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: "0 0 0.75rem 0 rgba(184, 184, 184, 0.5)",
    padding: "0 1.5rem"
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  rhscLogo: {
    width: 224,
    height: 47
  },
  toolbarGutters: {
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem"
  },
  toolbarHeight: {
    height: toolbarHeight
  },
  toolbarLinks: {
    marginLeft: "auto",
    display: "flex"
  },
  toolbarLink: {
    fontSize: "1rem",
    fontWeight: styleConstants.fontWeights.bold,
    color: styleConstants.colors.primary,
    "&:hover": {
      textDecoration: "none"
    },
    cursor: "pointer",
    marginLeft: "2rem"
  }
}));

const AppBar = props => {
  const classes = useStyles();

  return (
    <MuiAppBar
      position="fixed"
      color="inherit"
      className={classNames("AppBar", classes.container)}
    >
      <Toolbar
        className={classes.toolbarHeight}
        classes={{
          gutters: classes.toolbarGutters
        }}
      >
        <IconButton
          color="inherit"
          edge="start"
          className={classes.menuButton}
          onClick={props.onOpenNavigation}
        >
          <MenuIcon />
        </IconButton>

        <HyperLink href="https://www.rhsupplies.org/" icon={true}>
          <img src={rhscLogo} alt="RHSC logo" className={classes.rhscLogo} />
        </HyperLink>

        <Link to="intro" offset={-144} smooth={true}>
          <img
            src={cgaLogo}
            alt="CGA logo"
            className={classNames("cga-logo", classes.cgaLogo)}
          />
        </Link>

        <div className={classes.toolbarLinks}>
          {props.enableCountryExplorerOpening && (
            <div
              className={classes.toolbarLink}
              onClick={props.onOpenCountryExplorer}
            >
              Country Explorer
            </div>
          )}

          {props.enableAnnexOpening && (
            <div className={classes.toolbarLink} onClick={props.onOpenAnnex}>
              Data Annex
            </div>
          )}
        </div>
      </Toolbar>
    </MuiAppBar>
  );
};

AppBar.propTypes = {
  enableCountryExplorerOpening: PropTypes.bool,
  enableAnnexOpening: PropTypes.bool,
  onOpenNavigation: PropTypes.func,
  onOpenCountryExplorer: PropTypes.func,
  onOpenAnnex: PropTypes.func
};

AppBar.defaultProps = {
  enableCountryExplorerOpening: true,
  enableAnnexOpening: true
};

export default AppBar;
